import axios from 'axios'
import { UrlApi, authMail, authPass } from '../Keys'

const dataInicial = {
    resultadoPractica: [],
    loadingResultadoP: false,
    getResultadoP: null,
    resultadoGlobal: [],
    loadingResultadoG: false,
    getResultadoG: null,
    acompanamientos: [],
    loadingAcompanamientos: false,
    getAcompanamientos: null
}

const LOADING_RESULTADO_P = 'LOADING_RESULTADO_P'
const RESULTADO_PRACTICA = 'RESULTADO_PRACTICA'
const RESULTADO_PRACTICA_ERROR = 'RESULTADO_PRACTICA_ERROR'

const LOADING_RESULTADO_G = 'LOADING_RESULTADO_G'
const RESULTADO_GLOBAL = 'RESULTADO_GLOBAL'
const RESULTADO_GLOBAL_ERROR = 'RESULTADO_GLOBAL_ERROR'

const LOADING_ACOMPANAMIENTOS = 'LOADING_ACOMPANAMIENTOS'
const ACOMPANAMIENTOS = 'ACOMPANAMIENTOS'
const ACOMPANAMIENTOS_ERROR = 'ACOMPANAMIENTOS_ERROR'


//Reducers
export default function desempenoReducer(state = dataInicial, action) {
    switch (action.type) {
        case RESULTADO_PRACTICA:
            return { ...state, resultadoPractica: action.payload, loadingResultadoP: action.loadingResultadoP, getResultadoP: true }
        case LOADING_RESULTADO_P:
            return { ...state, loadingResultadoP: action.loadingResultadoP, getResultadoP: false }
        case RESULTADO_PRACTICA_ERROR:
            return { ...state, loadingResultadoP: action.loadingResultadoP, getResultadoP: true }

        case RESULTADO_GLOBAL:
            return { ...state, resultadoGlobal: action.payload, loadingResultadoG: action.loadingResultadoG, getResultadoG: true }
        case LOADING_RESULTADO_G:
            return { ...state, loadingResultadoG: action.loadingResultadoG, getResultadoG: false }
        case RESULTADO_GLOBAL_ERROR:
            return { ...state, loadingResultadoG: action.loadingResultadoG, getResultadoG: true }

        case ACOMPANAMIENTOS:
            return { ...state, acompanamientos: action.payload, loadingAcompanamientos: action.loadingAcompanamientos, getAcompanamientos: true }
        case LOADING_ACOMPANAMIENTOS:
            return { ...state, loadingAcompanamientos: action.loadingAcompanamientos, getAcompanamientos: false }
        case ACOMPANAMIENTOS_ERROR:
            return { ...state, loadingAcompanamientos: action.loadingAcompanamientos, getAcompanamientos: true }
        default:
            return { ...state }
    }
}

export const resultadoPracticaDocente = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_RESULTADO_P,
        loadingResultadoP: true
    })

    try {
        var entidad = "new_consolidadodeevaluacionesporperiodos"
        var fetch =
            "<entity name='new_consolidadodeevaluacionesporperiodo'>" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_consolidadodeevaluacionesporperiodoid' />" +
            "<attribute name='new_puestoenelranking' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_desempenio' />" +
            "<attribute name='new_creditostotales' />" +
            "<attribute name='new_crditosactprodcontenido' />" +
            "<attribute name='new_creditosactinvestigacion' />" +
            "<attribute name='new_creditosactgestion' />" +
            "<attribute name='new_creditosactextension' />" +
            "<attribute name='new_creditosactaulicas' />" +
            "<order attribute='new_name' descending='false' />" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_periodo' from='new_periodoid' to='new_periodo' link-type='inner' alias='bg'>" +
            "<attribute name='new_publicargestiondeldesempeno' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='1' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='annotation' from='objectid' to='new_consolidadodeevaluacionesporperiodoid' link-type='outer' alias='ac'>" +
            "<attribute name='subject' />" +
            "<attribute name='notetext' />" +
            "<attribute name='filename' />" +
            "<attribute name='annotationid' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: RESULTADO_PRACTICA,
            payload: response.data,
            loadingResultadoP: false
        })
    }
    catch (error) {
        console.log(error)
        dispatch({
            type: RESULTADO_PRACTICA_ERROR,
            loadingResultadoP: false
        })
    }
}

export const resultadoGlobalCarrera = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_RESULTADO_G,
        loadingResultadoG: true
    })

    try {
        var entidad = "new_consolidadodeevaluacionesporperiodos"
        var fetch =
            "<entity name='new_consolidadodeevaluacionesporperiodo'>" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_consolidadodeevaluacionesporperiodoid' />" +
            "<attribute name='new_puestoenelranking' />" +
            "<attribute name='new_periodo' />" +
            "<attribute name='new_desempenio' />" +
            "<attribute name='new_creditostotales' />" +
            "<attribute name='new_crditosactprodcontenido' />" +
            "<attribute name='new_creditosactinvestigacion' />" +
            "<attribute name='new_creditosactgestion' />" +
            "<attribute name='new_creditosactextension' />" +
            "<attribute name='new_creditosactaulicas' />" +
            "<order attribute='new_name' descending='false' />" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_periodo' from='new_periodoid' to='new_periodo' link-type='inner' alias='bg'>" +
            "<attribute name='new_publicargestiondeldesempeno' />" +
            "<filter type='and'>" +
            "<condition attribute='statuscode' operator='eq' value='1' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='annotation' from='objectid' to='new_consolidadodeevaluacionesporperiodoid' link-type='outer' alias='ac'>" +
            "<attribute name='subject' />" +
            "<attribute name='notetext' />" +
            "<attribute name='filename' />" +
            "<attribute name='annotationid' />" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: RESULTADO_GLOBAL,
            payload: response.data,
            loadingResultadoG: false
        })
    }
    catch (error) {
        console.log(error)
        dispatch({
            type: RESULTADO_GLOBAL_ERROR,
            loadingResultadoG: false
        })
    }
}

export const acompanamientosAulicos = (token, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_ACOMPANAMIENTOS,
        loadingAcompanamientos: true
    })

    try {
        var entidad = "new_observacionaulicas"
        var fetch =
            "<entity name='new_observacionaulica'>" +
            "<attribute name='new_observacionaulicaid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='createdon' />" +
            "<attribute name='new_observador' />" +
            "<attribute name='new_momentodelaclaseenqueseacompaa' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='new_fechadelaobservacin' />" +
            "<attribute name='new_diferencial' />" +
            "<attribute name='new_didctivasde2donivel' />" +
            "<attribute name='new_didacticasde1ernivel' />" +
            "<attribute name='new_informaciondiferencial'/>" +
            "<attribute name='new_descripcionfecha' />" +
            "<attribute name='new_comentariosyfeedbackfinal' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_comentariosyfeedbackfinal' operator='not-null' />" +
            "<condition attribute='new_fechadelaobservacin' operator='last-year'/>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortal + "' />" +
            // "<condition attribute='new_usuarioportalrh' operator='eq' value='36774240@docente.com' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: ACOMPANAMIENTOS,
            payload: response.data,
            loadingAcompanamientos: false
        })
    }
    catch (error) {
        console.log(error)
        dispatch({
            type: ACOMPANAMIENTOS_ERROR,
            loadingAcompanamientos: false
        })
    }
}
